import type { DatePickerLabelsType } from './DatePicker.types';

/**
 * Shortcut and action wording per supported locale. `locale` selects the set;
 * anything passed as `labels` overrides it field by field.
 */
export const DATE_PICKER_LABELS: Record<'en' | 'es', DatePickerLabelsType> = {
  en: {
    today: 'Today',
    yesterday: 'Yesterday',
    lastSevenDays: 'Last 7 days',
    monthToDate: 'Month to date',
    monthFromDate: 'Month from date',
    nextMonthFromDate: 'Next month from date',
    yearToDate: 'Year to date',
    yearFromDate: 'Year from date',
    nextYearFromDate: 'Next year from date',
    clear: 'Clear',
    submit: 'Submit',
  },
  es: {
    today: 'Hoy',
    yesterday: 'Ayer',
    lastSevenDays: 'Últimos 7 días',
    monthToDate: 'Mes en curso',
    monthFromDate: 'Fin de mes en curso',
    nextMonthFromDate: 'Siguiente mes',
    yearToDate: 'Año en curso',
    yearFromDate: 'Fin de año en curso',
    nextYearFromDate: 'Siguiente año',
    clear: 'Limpiar',
    submit: 'Aceptar',
  },
};
